import { forwardRef } from "react";
import { PhraseText, SoundVisualizerRef } from "../../types";
import { Box, Center, Text, useTheme } from "@chakra-ui/react";
import { BarSoundVisualizerV2 } from "../atoms/BarSoundVisualizerV2";
import { CALIBRATION_MIN_LOG_POWER } from "../../constants";
import { decibelToVolume } from "../../utils/calcVolume";

type PhraseVisualizerProps = {
  currentPhrase: PhraseText;
};
export const PhraseBarSoundVisualizer = forwardRef<
  SoundVisualizerRef,
  PhraseVisualizerProps
>((props, ref) => {
  const theme = useTheme();
  const underThreshold = decibelToVolume(CALIBRATION_MIN_LOG_POWER);
  const isCalcRecording = props.currentPhrase.title.includes("CALC");

  return (
    <Box
      position="relative"
      minHeight={{
        base: isCalcRecording ? "120px" : "320px",
        sm: "440px",
      }}
      width="100%"
    >
      <BarSoundVisualizerV2
        ref={ref}
        upperThreshold={0.81}
        underThreshold={underThreshold}
        maxValue={1}
        height="40px"
        width="100%"
      />
      <Center
        position="absolute"
        w="full"
        h={isCalcRecording ? "70px" : "370px"}
        flexDirection="column"
        mt="20px"
        justifyContent="flex-start"
      >
        <Text
          maxWidth="100%"
          fontSize={{
            base: "3xl",
            sm: "4xl",
          }}
          textAlign="center"
          whiteSpace="pre-wrap"
          color="primary.theme_lv4"
          fontWeight={900}
          lineHeight={1.2}
          width="100%"
          height={{
            base: "200px",
            sm: "250px",
          }}
          display="flex"
          justifyContent="center"
          alignItems="center"
          borderWidth="4px"
          borderStyle="solid"
          borderColor={theme.colors.primary["theme_lv1"]}
          bg={theme.colors.common["base"]}
          borderRadius="16px"
        >
          {props.currentPhrase.phrase}
        </Text>
        <Text
          width="100%"
          textAlign="center"
          whiteSpace="pre-wrap"
          fontSize={{
            base: "xl",
            sm: "2xl",
          }}
          mt="10px"
        >
          {props.currentPhrase.helperText || ""}
        </Text>
      </Center>
    </Box>
  );
});
PhraseBarSoundVisualizer.displayName = "PhraseVisualizer";
